export default "__VITE_ASSET__Buf_$LFt__"